import { render, staticRenderFns } from "./IssueViewer.vue?vue&type=template&id=782adf4e&scoped=true&"
import script from "./IssueViewer.vue?vue&type=script&lang=js&"
export * from "./IssueViewer.vue?vue&type=script&lang=js&"
import style0 from "./IssueViewer.vue?vue&type=style&index=0&id=782adf4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782adf4e",
  null
  
)

export default component.exports